import { SUPPLY_MODEL_LABELS, type SupplyModel } from '../api/agreements.ts';

// CB-REQ VEN-11 at v1.988 (venue slice 4A): how the venue on a quote or job is billed. It defaults
// from the venue's agreement and may be changed while the quote is open, or on a job until it is
// first invoiced; the database refuses the rest. Standard is an ordinary sale, so it shows no tag.

const CHOICES: SupplyModel[] = ['standard', 'resale', 'direct_bill'];

export function SupplyModelField({
  current,
  note,
  editable,
  saving,
  error,
  onChange,
}: {
  current: SupplyModel;
  note?: 'agency-not-built' | null | undefined;
  editable: boolean;
  saving: boolean;
  error: Error | null;
  onChange: (supplyModel: SupplyModel) => void;
}) {
  if (!editable && current === 'standard' && !note) return null;
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <span className="text-ink-soft">Venue billing</span>
        {editable ? (
          <select
            className="input w-auto"
            aria-label="Venue billing"
            value={current}
            disabled={saving}
            onChange={(e) => onChange(e.currentTarget.value as SupplyModel)}
          >
            {CHOICES.map((c) => (
              <option key={c} value={c}>
                {SUPPLY_MODEL_LABELS[c]}
              </option>
            ))}
          </select>
        ) : current !== 'standard' ? (
          <span className="tag">{SUPPLY_MODEL_LABELS[current]}</span>
        ) : null}
      </div>
      {note === 'agency-not-built' ? (
        <p className="text-sm text-ink-soft">
          The venue’s agreement is agency, which isn’t billed here yet: this is a standard sale.
        </p>
      ) : null}
      {error ? (
        <p role="alert" className="text-sm font-semibold text-accent-2-700">
          {error.message}
        </p>
      ) : null}
    </div>
  );
}
